<template>
  <div class="trial-order-tab tb">
    <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
    <manage v-if="`${tabIndex}` === '0'"></manage>
    <device-list v-if="`${tabIndex}` === '1'"></device-list>
  </div>
</template>

<script>
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import manage from './children/manage.vue';
import deviceList from './children/deviceList.vue';

export default {
  name: 'trialOrderManagement',
  mixins: [tableFilterValueMixins],
  props: {},
  components: {
    deviceList,
    manage,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    tabData() {
      const tabData = [];
      if (this.funcView.trial_order_manage_list) {
        tabData.push({
          name: this.$t('crm_trialOrderManagement.ding_dan'),
          value: 0,
        });
      }
      if (this.funcView.trial_order_manage_device_list) {
        tabData.push({
          name: this.$t('crm_trialOrderManagement.she_bei'),
          value: 1,
        });
      }
      return tabData;
    }
  },
  mounted() {
    this.getFuncView(null, () => {
      // 设置默认选中的tab
      if (this.funcView.trial_order_manage_list) {
        this.tabIndex = 0;
      } else if (this.funcView.trial_order_manage_device_list) {
        this.tabIndex = 1;
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.trial-order-tab {
  padding-left: 0 !important;
}
</style>
